import { render, staticRenderFns } from "./BoxModal.vue?vue&type=template&id=4f9a4b52&"
import script from "./BoxModal.vue?vue&type=script&lang=js&"
export * from "./BoxModal.vue?vue&type=script&lang=js&"
import style0 from "./BoxModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports